import React, { useState, useEffect, use } from 'react';
import './SolverSettings.css';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import UndoIcon from '@mui/icons-material/Undo';
import JobSelection from "./JobSelection";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Icon from '@mui/material/Icon';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import MissingPieces from "./MissingPieces";
import SetSelection from "./SetSelection";
import Zoom from '@mui/material/Zoom';
import SettingsIcon from '@mui/icons-material/Settings';
import Grow from '@mui/material/Grow';
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function SolverSettings(props) {

    const players = props.players;

    const [data, setData] = useState({
        static: structuredClone(props.static),
        staticCopy: structuredClone(props.static),
        selected: null,
        selectedGroup: null,
        modified: false,
    })

    function settingsTrigger() {
        setData({ ...data, trigger: !data.trigger })
    }

    function close() {
        setData({ ...data, trigger: false })
    }

    function closePopup() {
        setData({ ...data, trigger: false })
    }

    function test(e) {
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
    }

    function setSettingsCheckBox(e, setting) {
        var _static = data.static;
        _static.settings[setting] = e.target.checked;
        setData({ ...data, static: _static, modified: true })
    }

    function saveSettings() {
        props.updateStatic(data.static)
        setData({ ...data, staticCopy: structuredClone(data.static), modified: false })
    }

    function undoChanges() {
        setData({ ...data, static: structuredClone(data.staticCopy), modified: false })
    }

    function selectPlayer(playerID, group) {
        console.log(data)
        setData({ ...data, selected: playerID, selectedGroup: group })
    }

    function normalizeName(player) {
        if (player.length > 12)
            return `${player.substring(0, 12)}...`;
        return player;
    }

    function moveFromG1ToG2() {
        var _static = data.static;
        var g1 = _static.settings.g1;
        var g2 = _static.settings.g2;
        var index = g1.indexOf(data.selected);
        if (index !== -1) {
            g1.splice(index, 1);
        }
        g2.push(data.selected);
        setData({ ...data, static: _static, selected: null, selectedGroup: null, modified: true })
    }

    function moveFromG2ToG1() {
        var _static = data.static;
        var g1 = _static.settings.g1;
        var g2 = _static.settings.g2;
        var index = g2.indexOf(data.selected);
        if (index !== -1) {
            g2.splice(index, 1);
        }
        g1.push(data.selected);
        setData({ ...data, static: _static, selected: null, selectedGroup: null, modified: true })
    }

    function itemText(playerID) {
        if (players[playerID].role === 'dps')
            return `#ff5454`;
        else if (players[playerID].role === 'healer')
            return `#4ff45b`;
        else if (players[playerID].role === 'tank')
            return `#4fb1f4`;
    }

    function itemBG(playerID) {
        if (data.selected === playerID) {
            console.log(true)
            return `2px solid #737373`;
        }
        else {
            return 'none';
        }
    }

    function generateGroupLists() {
        if (!data.static.settings.g1 || !data.static.settings.g2)
            return;
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Grid container>
                    <Grid size={5}>
                        <div style={{ marginLeft: '-40px' }}>
                            G1
                        </div>
                        <List sx={{
                            width: 250,
                            position: 'relative',
                            overflow: 'auto',
                            overflowX: 'hidden',
                            maxHeight: 300,
                            marginLeft: '-40px',
                            "&::-webkit-scrollbar": {
                                width: '10px',
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: 'none',
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: '#555555',
                                borderRadius: '10px',
                                border: '1px solid black',
                            },
                            // hover states
                            '& .MuiListItemButton-root:hover': {
                                bgcolor: '#242424',
                            },

                        }}>
                            {data.static.settings.g1.map((playerID) => (
                                <ListItemButton key={`g1-${playerID}`} className='items' onClick={() => selectPlayer(playerID, 'g1')} style={{ color: `${itemText(playerID)}`, border: `${itemBG(playerID)}`, borderRadius: '15px' }}>
                                    <ListItemText primary={`${normalizeName(players[playerID].name)}`} slotProps={{ primary: { fontFamily: 'Noto Sans' } }} />
                                </ListItemButton>
                            ))}
                        </List>
                    </Grid>
                    <Grid size={2}>
                        <div className='g1g2-navigation-container'>
                            <div >
                                <Button className='navigation' variant="contained" onClick={moveFromG2ToG1} disabled={data.selectedGroup !== 'g2'}><ChevronLeftIcon style={{ color: '#fad99a' }} /></Button>
                            </div>
                            <div>
                                <Button className='navigation' variant="contained" onClick={moveFromG1ToG2} disabled={data.selectedGroup !== 'g1'}><ChevronRightIcon style={{ color: '#fad99a' }} /></Button>
                            </div>
                        </div>
                    </Grid>
                    <Grid size={5}>
                        <div style={{ marginLeft: '40px' }}>
                            G2
                        </div>
                        <List sx={{
                            width: 250,
                            position: 'relative',
                            overflow: 'auto',
                            overflowX: 'hidden',
                            maxHeight: 300,
                            "&::-webkit-scrollbar": {
                                width: '10px',
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: 'none',
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: '#555555',
                                borderRadius: '10px',
                                border: '1px solid black',
                            },
                            // hover states
                            '& .MuiListItemButton-root:hover': {
                                bgcolor: '#242424',
                            },

                        }}>
                            {data.static.settings.g2.map((playerID) => (
                                <ListItemButton key={`g2-${playerID}`} className='items' onClick={() => selectPlayer(playerID, 'g2')} style={{ color: `${itemText(playerID)}`, border: `${itemBG(playerID)}`, borderRadius: '15px' }}>
                                    <ListItemText primary={`${normalizeName(players[playerID].name)}`} slotProps={{ primary: { fontFamily: 'Noto Sans' } }} />
                                </ListItemButton>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </div>
        )
    }

    useEffect(() => {
        if (!props.static.settings.g1)
            props.static.settings['g1'] = [0, 1, 2, 3, 4, 5, 6, 7];
        if (!props.static.settings.g2)
            props.static.settings['g2'] = [];

        //failsafe
        if (props.static.settings.g1.length + props.static.settings.g2.length > 8) {
            props.static.settings['g1'] = [0, 1, 2, 3, 4, 5, 6, 7];
            props.static.settings['g2'] = [];
        }
        setData({ ...data, static: structuredClone(props.static) })
    }, [])

    return (
        <div>
            <div>
                <Button id='static-settings' variant="contained" onClick={settingsTrigger}><SettingsIcon style={{ color: '#fad99a' }} /></Button>
                <Zoom in={data.trigger}>
                    <div className="popup3" onClick={closePopup}>
                        <div className='outer3'>
                            <div className="popup-inner3" onClick={test} >
                                <div style={{ fontSize: '24px', marginTop: '-40px' }}>Solver Settings</div>
                                <div style={{ marginBottom: '40px', fontSize: '14px' }}>Only available distribution types are dps → tanks → healers and equal across all (for now)</div>
                                <div><Button className='close-btn3' variant="contained" onClick={close}><CloseIcon style={{ color: '#fad99a' }} /></Button> </div>
                                <div className='settings-group'>
                                    <div className="settings-title">
                                        General loot settings
                                    </div>
                                    Alts
                                    <Checkbox
                                        checked={data.static.settings.alts}
                                        onChange={(e) => setSettingsCheckBox(e, 'alts')}
                                        sx={{
                                            color: '#b7b7b7',
                                            '&.Mui-checked': {
                                                color: 'aliceblue',
                                            },
                                            borderRadius: '0px'
                                        }}
                                    />
                                    Equal Loot Distribution
                                    <Checkbox
                                        checked={data.static.settings.equalDistribution}
                                        onChange={(e) => setSettingsCheckBox(e, 'equalDistribution')}
                                        sx={{
                                            color: '#b7b7b7',
                                            '&.Mui-checked': {
                                                color: 'aliceblue',
                                            },
                                            borderRadius: '0px'
                                        }}
                                    />
                                    Splits
                                    <Checkbox
                                        checked={data.static.settings.splits}
                                        onChange={(e) => setSettingsCheckBox(e, 'splits')}
                                        sx={{
                                            color: '#b7b7b7',
                                            '&.Mui-checked': {
                                                color: 'aliceblue',
                                            },
                                            borderRadius: '0px'
                                        }}
                                    />
                                </div>

                                <div className='settings-group'>
                                    <div className="settings-title">
                                        Augment settings
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                                        Separate Augments
                                        <Checkbox
                                            checked={data.static.settings.augmentEnabled}
                                            onChange={(e) => setSettingsCheckBox(e, 'augmentEnabled')}
                                            sx={{
                                                color: '#b7b7b7',
                                                '&.Mui-checked': {
                                                    color: 'aliceblue',
                                                },
                                                borderRadius: '0px'
                                            }}
                                        />
                                        <Collapse in={data.static.settings.augmentEnabled}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                Equal Distrib.
                                                <Checkbox
                                                    checked={data.static.settings.equalAugments}
                                                    onChange={(e) => setSettingsCheckBox(e, 'equalAugments')}
                                                    sx={{
                                                        color: '#b7b7b7',
                                                        '&.Mui-checked': {
                                                            color: 'aliceblue',
                                                        },
                                                        borderRadius: '0px'
                                                    }}
                                                />
                                            </div>
                                        </Collapse>
                                    </div>
                                </div>
                                <Collapse in={data.static.settings.splits}>
                                    {generateGroupLists()}
                                </Collapse>

                                <Grow in={data.modified}>

                                    <div style={{ marginTop: '25px' }}>
                                        <Button style={{ width: "70%", borderRadius: '0px', height: '30px', backgroundColor: '#37373a' }}
                                            variant="contained" id="submit" color="primary" type="submit" onClick={saveSettings}>Save</Button>
                                        <Button style={{ width: "30%", borderRadius: '0px', height: '30px', background: '#e25757', minWidth: "0px" }}
                                            variant="contained" id="submit" color="primary" type="submit" onClick={undoChanges}><UndoIcon /></Button>
                                    </div>

                                </Grow>
                            </div>
                        </div>

                    </div>
                </Zoom>
            </div>

        </div>
    );
}

export default SolverSettings;